"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ability_PowerApex_OnAttack = exports.PowerApexActorAbilityFactory = exports.PowerApexAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const core_1 = require("../../core/event-handlers/core");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
const Registries_1 = require("../../core/state/Registries");
class PowerApexAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.PowerApex;
        this.__typeName = "PowerApex";
    }
}
exports.PowerApexAbilityArgs = PowerApexAbilityArgs;
let PowerApexActorAbilityFactory = class PowerApexActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("PowerApex", "Self", 0);
    }
};
PowerApexActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("PowerApex")
], PowerApexActorAbilityFactory);
exports.PowerApexActorAbilityFactory = PowerApexActorAbilityFactory;
let Ability_PowerApex_OnAttack = class Ability_PowerApex_OnAttack {
    init(sequence, container, actorId) {
        const eventHandlerId = container.registerEventHandler(actorId, EventType_1.EventType.Attack, Schedule_1.Schedule.Unlimited, new core_1.CustomScriptEventHandlerArgs("Ability_PowerApex_OnAttack", {}));
        container.registerEventHandler(actorId, EventType_1.EventType.Killed, Schedule_1.Schedule.Once(), new core_1.CancelEventHandlersEventHandlerArgs([eventHandlerId]));
    }
    activate(sequence, container, ability) {
        throw new Error("PASSIVE_ONLY");
    }
};
Ability_PowerApex_OnAttack = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.PowerApex)
], Ability_PowerApex_OnAttack);
exports.Ability_PowerApex_OnAttack = Ability_PowerApex_OnAttack;
